import {
  REQUEST_INVITATION_LIST,
  REQUEST_INVITATION,
  REQUEST_KIOSK_INFO
} from './mutation-types'

export default {
  [REQUEST_INVITATION_LIST] (state, receivedData) {
    state.invitations = receivedData.content;
    state.invitationCount = receivedData.totalElements;
  },
  [REQUEST_INVITATION] (state, receivedData) {
    state.invitation = receivedData;
  },
  [REQUEST_KIOSK_INFO] (state, receivedData) {
    state.kioskInfo = receivedData
  }
}